import { Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext.tsx'
import LoginPage from './pages/LoginPage.tsx'
import LocumLayout from './layouts/LocumLayout.tsx'
import PracticeLayout from './layouts/PracticeLayout.tsx'
import LoadingSpinner from './components/ui/LoadingSpinner.tsx'

function AppContent() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  if (!user) {
    return <LoginPage />
  }

  // Route based on user role
  if (user.role === 'locum') {
    return <LocumLayout />
  }

  if (user.role === 'practice') {
    return <PracticeLayout />
  }

  // Fallback for other roles or invalid state
  return <Navigate to="/login" replace />
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App
